import { LoadingIndicator, Modal } from "@lululemon/ui-library";
import { useQVMContext } from "./hooks";
import styles from "./quick-view-modal.module.scss";

/**
 * This component renders the PL modal and passes to it
 * the necessary information to work, also handles the
 * loading state presentation.
 * @param {*} param0
 * @returns
 */
const ModalRenderer = ({ children }) => {
  const { error, isLoading, onClose, visible, isMobile } = useQVMContext();
  const modalClassNames = [
    styles.modal,
    styles.quickViewModal,
    (Boolean(error) && styles.error) || "",
    (isLoading && styles.loading) || "",
  ]
    .join(" ")
    .trim();

  return (
    <Modal
      classes={{
        modal: modalClassNames,
        modalContent: styles.container,
      }}
      messages={{ close: "Close" }}
      visible={visible}
      onRequestClose={onClose}
      fullScreenMobile={isMobile}
    >
      {isLoading ? <LoadingIndicator /> : children}
    </Modal>
  );
};

export default ModalRenderer;
